/**
 * Shared mixin for all wizard field components.
 * Provides common props, computed helpers, and the emit pattern.
 */
export default {
    props: {
        attribute: { type: Object, required: true },
        value: { default: null },
        locale: { type: String, default: 'fr' },
        error: { type: String, default: null }
    },
    computed: {
        label() {
            // Backend resolves locale directly on attribute
            if (this.attribute.label) return this.attribute.label
            const t = this.getTranslation()
            return t.label || ''
        },
        instruction() {
            if (this.attribute.instruction) return this.attribute.instruction
            const t = this.getTranslation()
            return t.instruction || ''
        },
        help() {
            if (this.attribute.help) return this.attribute.help
            const t = this.getTranslation()
            return t.help || ''
        },
        description() {
            if (this.attribute.description) return this.attribute.description
            const t = this.getTranslation()
            return t.description || ''
        },
        isRequired() {
            return !!(this.attribute.requiredPublic || this.attribute.requiredForWizard)
        }
    },
    methods: {
        getTranslation() {
            if (!this.attribute.translations) return {}
            if (Array.isArray(this.attribute.translations)) {
                return this.attribute.translations.find((t) => t.locale === this.locale) || {}
            }
            return this.attribute.translations[this.locale] || {}
        },
        emitValue(val) {
            this.$emit('input', val)
        }
    }
}
